import { getData, postData } from '@/utils/http';
import config from '@/config';
export default {
  namespaced: true,
  state: {
    tableLoading: true,
    addLoading: false,
    activeItem: null,
    tableList: [],
    //选中的订单
    activeWayBill: null,
    total: 0, 
    query: {
      code: '',
      status: '',
      carNo: '',
      driver: '',
      projectId: '',
      page: 1,
      size: config.pageSize
    },
   
  },
  mutations: {
    CHANGE_TABLE_LOADING(state, tableLoading) {
      state.tableLoading = tableLoading;
    },
    CHANGE_ADD_LOADING(state, addLoading) {
      state.addLoading = addLoading;
    },
    CHANGE_TABLE_DATA(state, changeData) {
      state.tableList = changeData.data.rows;
      state.total = changeData.total;
    },
    CHANGE_ACTIVE_ITEM(state, item) {
      state.activeItem = item;
    },
    CHANGE_SEARCH_COLL(state, changeData) {
      if (
        changeData['changeKey'] == 'orgId' &&
        typeof changeData['data'] != 'object'
      ) {
        state.query[changeData['changeKey']] = [changeData['data']];
      } else {
        state.query[changeData['changeKey']] = changeData['data'];
      }
    },
    CHANGE_TABLE_INDEX(state, value) {
      state.query.page = value;
    },
    setProjectId(state,data) {
      state.query.projectId = data;
    }
  },
  actions: {
    //获取列表
    getList({ commit, state }) {
      return new Promise((resolve) => {
        getData(`logistics/waybill/exception/page`, state.query).then((res) => {
          if (res.state == 1) {
            commit('CHANGE_TABLE_DATA', res);
            resolve({
              state: 1,
              msg: '操作成功',
            });
          } else {
            resolve({
              state: 0,
              msg: res.msg,
            });
          }
        });
      });
    },

    //拒绝
    exceptionRefuse({ commit }, data) {
      return new Promise((resolve) => {
        postData(`logistics/waybill/exception/refuse`, data).then((res) => {
          if (res.state == 1) {
            resolve({
              state: 1,
              msg: '操作成功',
            });
          } else {
            resolve({
              state: 0,
              msg: res.msg,
            });
          }
        });
      });
    },
    
    //通过
    exceptionPass({ commit }, data) {
      return new Promise((resolve) => {
        postData(`logistics/waybill/exception/pass`, data).then((res) => {
          if (res.state == 1) {
            resolve({
              state: 1,
              msg: '操作成功',
            });
          } else {
            resolve({
              state: 0,
              msg: res.msg,
            });
          }
        });
      });
    },
//获取我的项目列表
		getMyProjectList({ commit, state },deptId) {
			return new Promise(resolve => { 
				getData(`logistics/project/my/list?deptId=${deptId}`).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: '操作成功',
							data: res.data
						})
					} else {
						resolve({
							state: 0,
							msg: res.msg,
							data: []
						})
					}
				})
			})
		}, 

    //写入当前操作条目
    setActiveItem({ commit }, item) {
      commit('CHANGE_ACTIVE_ITEM', item);
    },
 
    //修改分页
    setPageIndex({ commit }, value) {
      commit('CHANGE_TABLE_INDEX', value);
    },
    //修改添加loading
    changeAddLoading({ commit }, value) {
      commit('CHANGE_ADD_LOADING', value);
    },
    //修改添加loading
    changeListLoading({ commit }, value) {
      commit('CHANGE_TABLE_LOADING', value);
    },
  },
};
